<template>
  <div class="driver-info" :style="{height:InfoHeight+'px'}">
    <div class="driver-detail" v-if="model.id">
      <div class="driver-cloum" style="margin-top: 24px">
        <img  :src="getFileAccessHttpUrl(model.logo || 'https://oss.dimoclub.com/static/driver/default_logo.png')">
      </div>

      <div class="driver-cloum driver-name">{{model.platformName}}</div>
      <div class="driver-cloum driver-number">{{model.currentStatusStr}}</div>
    </div>
    <div :style="{height:contentHeight+'px'}" class="driver-overflow">
      <div class="driver-baseinfo">
        <div class="base-item" v-for="item in tabList" :class="item.tab==leftMap.leftTab?'active':''" @click="clickTab(item.tab)">
          <div class="base-title">
            <div class="left-title">{{item.title}}</div>
            <div class="right-count"></div>
          </div>
          <div class="base-content">
            <img :title="item.realName" :src="getFileAccessHttpUrl(item.headImg || 'https://oss.dimoclub.com/static/driver/defalut_icon.png')" v-if="item.headImg"/>
            <span v-if="item.operateType && item.operateTime">更新于{{item.operateTime}}</span>
            <span v-else>暂无信息</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import {getFileAccessHttpUrl,deleteAction} from '@/api/manage'
  export default {
    name: 'PlatformInfo',
    components: {},
    props:{
      leftMap:{
        type:Object,
        default: {}
      },
      model:{
        type:Object,
        default: {}
      }
    },
    data() {
      return {
        contentHeight:document.documentElement.clientHeight,
        InfoHeight:document.documentElement.clientHeight-128,
        tabListDefault:[
          {
            title:"基本信息",
            headImg:null,
            operateType:0,
            tab:1,
            operateTime:null
          },
          {
            title:"月数据(GMV)",
            headImg:null,
            operateType:0,
            tab:2,
            operateTime:null
          },{
            title:"司机信息",
            headImg:null,
            operateType:0,
            tab:3,
            operateTime:null
          }
        ],
        tabList:[],
        getFileAccessHttpUrl:getFileAccessHttpUrl,
        numArr:[0,0,0]
      }
    },methods:{
      edit(){
        this.tabList = [];
        let operateMap = {}
        if(this.model.operateDriverList){
          for(let a in this.model.operateDriverList){
            operateMap[this.model.operateDriverList[a].tab] = this.model.operateDriverList[a];
          }
        }
        for(let b in this.tabListDefault){
          let v = operateMap[this.tabListDefault[b].tab]
          let tab = Object.assign(this.tabListDefault[b],{});

          if(v){
            tab.headImg = v.headImg || 'https://oss.dimoclub.com/static/driver/defalut_icon.png';
            tab.operateType = v.operateType;
            tab.operateTime = v.operateTime;
            tab.realName = v.realName;
          }else{
            tab.headImg = null;
            tab.operateType = b;
            tab.operateTime = null;
          }
          this.tabList.push(tab)
        }

      },clickTab(tab){
        if(tab==this.leftMap.leftTab && !this.leftMap.page){
          return;
        }
        let tb = this.tabListDefault[tab-1];
        this.$emit('change',{f:"",s:tb.title,page:"",leftTab:tab});
      },submitCallback(){
        this.$emit("update",1);
      }
    }
  }
</script>
<style lang="less" scoped>
  .driver-info{
    background: #fff;
    width: 265px;
    border-radius: 12px;
  }
  .driver-title{
    height: 50px;
    line-height: 50px;
    padding-left: 24px;
    font-size: 16px;
    color:  rgba(10, 22, 41, 1);
    border-bottom: 1px solid rgba(230, 237, 245, 1);

  }

  .driver-detail{
    text-align: center;
    padding-bottom: 12px;
    border-bottom: 1px solid rgba(230, 237, 245, 1);
  }

  .driver-cloum{
    line-height: 36px;
  }
  .driver-cloum img{
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }
  .driver-name{
    font-size: 16px;
    color: rgb(10, 22, 41);
  }
  .driver-number{
    color: rgba(145, 146, 158, 1);
  }
  .driver-city,.driver-label,.driver-sub{
    font-size: 12px;
    cursor: pointer;
  }
  .driver-label span,.driver-city span{
    padding: 2px 5px;
  }
  .driver-city span{
    color: rgba(125, 133, 146, 1);
    border: 1px solid rgba(125, 133, 146, 1);
  }
  .driver-label span{
    background: rgba(196, 24, 230, 0.12);
    color: rgba(196, 24, 230, 1);
  }

  .driver-sub span{
    border: 1px solid #43CF7C;
    padding: 3px;
    border-radius: 4px;
  }
  .driver-sub span.qg{
    border: 1px solid rgba(125, 133, 146, 1);
    color: rgba(125, 133, 146, 1);
  }

  .driver-sub span.gz{
    border: 1px solid #43CF7C;
    color: #43CF7C;
  }

  .driver-baseinfo{
    padding: 12px;
    background: #fff;
    border-bottom: 1px solid #e6edf5;
  }
  .base-item{
    padding: 12px;
    border-radius: 12px;
    cursor: pointer;
  }
  .base-item.active{
    background: rgba(232, 241, 255, 1);
  }

  .base-item.active .base-title .left-title{
    color: rgba(24, 144, 255, 1);
  }
  .base-item .base-title{
    font-size: 16px;
    color: rgb(10, 22, 41);
    display: flex;
    justify-content: space-between;
  }
  .base-item .base-title .right-count .num{
    color: rgba(24, 144, 255, 1);
  }
  .base-item .base-content{
    margin-top: 12px;

  }
  .base-content img{
    width: 24px;
    height: 24px;
    border-radius: 50%;
  }
  .base-content span{
    color: rgba(145, 146, 158, 1);
    vertical-align: middle;
    margin-left: 3px;
  }
  .driver-join{
    padding: 24px;
    height: 100px;
    background: #fff;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
  }
  .join-person{
    color: rgba(145, 146, 158, 1);
  }
  .join-img{
    margin-top: 5px;
    position: relative;
  }
  .join-img img{
    width: 24px;
    height: 24px;
    border: 2px solid rgba(255, 255, 255, 1);
    border-radius: 50%;
    position: absolute;
    top: 0;
    left: 0;
    cursor: pointer;
  }
.driver-overflow {
  overflow-y: auto;
}

  .driver-overflow::-webkit-scrollbar{
    width: 0px;
  }

  .driver-overflow:hover::-webkit-scrollbar{
    width: 8px;
  }
</style>